var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 52,
    viewBox: "0 0 181 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.595 52H7.1575C3.49754 52 0.5 49.0734 0.5 45.5V6.5C0.5 2.92663 3.49754 2.74817e-06 7.1575 2.74817e-06H173.595C177.255 2.74817e-06 180.253 2.92663 180.253 6.5V45.5C180.253 49.0734 177.255 52 173.595 52Z",
    fill: "#DCE3E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2215 20.9775C88.0942 20.9775 85.5394 23.3013 85.5394 26.5074C85.5394 29.6875 88.0942 32.0356 91.2215 32.0356C94.3555 32.0356 96.9104 29.6875 96.9104 26.5074C96.9104 23.3013 94.3555 20.9775 91.2215 20.9775ZM91.2215 29.8581C89.5056 29.8581 88.0293 28.4753 88.0293 26.5074C88.0293 24.5135 89.5056 23.155 91.2215 23.155C92.9375 23.155 94.4205 24.5135 94.4205 26.5074C94.4205 28.4753 92.9375 29.8581 91.2215 29.8581V29.8581ZM78.8236 20.9775C75.6896 20.9775 73.1414 23.3013 73.1414 26.5074C73.1414 29.6875 75.6896 32.0356 78.8236 32.0356C81.9559 32.0356 84.5058 29.6875 84.5058 26.5074C84.5058 23.3013 81.9559 20.9775 78.8236 20.9775ZM78.8236 29.8581C77.106 29.8581 75.6247 28.4753 75.6247 26.5074C75.6247 24.5135 77.106 23.155 78.8236 23.155C80.5396 23.155 82.0159 24.5135 82.0159 26.5074C82.0159 28.4753 80.5396 29.8581 78.8236 29.8581ZM64.0706 22.6724V25.0221H69.8177C69.6496 26.3351 69.2002 27.3004 68.5111 27.9731C67.6723 28.7856 66.3657 29.6875 64.0706 29.6875C60.5338 29.6875 57.7643 26.9006 57.7643 23.4475C57.7643 19.9944 60.5338 17.2075 64.0706 17.2075C65.9829 17.2075 67.3744 17.9371 68.4013 18.8829L70.0973 17.227C68.6609 15.888 66.7502 14.8594 64.0706 14.8594C59.2206 14.8594 55.1445 18.7123 55.1445 23.4475C55.1445 28.1828 59.2206 32.0356 64.0706 32.0356C66.692 32.0356 68.6609 31.1971 70.2088 29.6241C71.7949 28.0755 72.2893 25.898 72.2893 24.1398C72.2893 23.5938 72.2427 23.0916 72.1594 22.6724H64.0706ZM124.398 24.494C123.93 23.2574 122.487 20.9775 119.548 20.9775C116.635 20.9775 114.21 23.2184 114.21 26.5074C114.21 29.6046 116.61 32.0356 119.827 32.0356C122.429 32.0356 123.93 30.487 124.547 29.5851L122.617 28.329C121.973 29.2488 121.095 29.8581 119.827 29.8581C118.567 29.8581 117.663 29.2943 117.084 28.1828L124.659 25.1229L124.398 24.494V24.494ZM116.675 26.3351C116.61 24.2031 118.371 23.1111 119.632 23.1111C120.621 23.1111 121.46 23.5938 121.74 24.2844L116.675 26.3351V26.3351ZM110.518 31.6993H113.008V15.4493H110.518V31.6993ZM106.441 22.2093H106.357C105.798 21.5625 104.731 20.9775 103.38 20.9775C100.544 20.9775 97.9506 23.4085 97.9506 26.5253C97.9506 29.6241 100.544 32.0356 103.38 32.0356C104.731 32.0356 105.798 31.4458 106.357 30.7795H106.441V31.5725C106.441 33.6866 105.284 34.8225 103.418 34.8225C101.897 34.8225 100.953 33.75 100.564 32.8481L98.3983 33.7305C99.0225 35.1963 100.675 37 103.418 37C106.337 37 108.801 35.323 108.801 31.2426V21.3139H106.441V22.2093V22.2093ZM103.593 29.8581C101.877 29.8581 100.44 28.4558 100.44 26.5253C100.44 24.5769 101.877 23.155 103.593 23.155C105.284 23.155 106.617 24.5769 106.617 26.5253C106.617 28.4558 105.284 29.8581 103.593 29.8581V29.8581ZM136.055 15.4493H130.1V31.6993H132.583V25.5421H136.055C138.813 25.5421 141.517 23.5938 141.517 20.4949C141.517 17.3976 138.806 15.4493 136.055 15.4493V15.4493ZM136.12 23.2818H132.583V17.7096H136.12C137.974 17.7096 139.032 19.2128 139.032 20.4949C139.032 21.7526 137.974 23.2818 136.12 23.2818ZM151.47 20.9466C149.676 20.9466 147.81 21.7201 147.043 23.4345L149.247 24.3364C149.721 23.4345 150.593 23.142 151.515 23.142C152.803 23.142 154.11 23.8976 154.13 25.2318V25.4024C153.681 25.1489 152.719 24.7735 151.535 24.7735C149.162 24.7735 146.743 26.0491 146.743 28.4298C146.743 30.6073 148.687 32.0096 150.873 32.0096C152.544 32.0096 153.466 31.2735 154.045 30.4171H154.13V31.6732H156.528V25.4398C156.528 22.5586 154.325 20.9466 151.47 20.9466ZM151.171 29.8516C150.358 29.8516 149.227 29.4584 149.227 28.4753C149.227 27.2175 150.638 26.7349 151.86 26.7349C152.953 26.7349 153.466 26.9705 154.13 27.2809C153.935 28.7856 152.609 29.8516 151.171 29.8516V29.8516ZM165.266 21.3025L162.412 28.3469H162.327L159.376 21.3025H156.698L161.132 31.1468L158.602 36.6246H161.197L168.029 21.3025H165.266V21.3025ZM142.882 31.6993H145.372V15.4493H142.882V31.6993Z",
    fill: "#2A3F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3943 9.80044C14.0032 10.2002 13.7769 10.8226 13.7769 11.6286V40.3781C13.7769 41.1841 14.0032 41.8064 14.3943 42.2062L14.4909 42.2939L30.9915 26.1902V25.8099L14.4909 9.7062L14.3943 9.80044Z",
    fill: "url(#paint0_linear_3279_8563)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4853 31.5605L30.9912 26.1899V25.8097L36.492 20.439L36.6151 20.5089L43.1295 24.1278C44.9886 25.1548 44.9886 26.8448 43.1295 27.8783L36.6151 31.4907L36.4853 31.5605V31.5605Z",
    fill: "url(#paint1_linear_3279_8563)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6151 31.4907L30.9912 25.9998L14.394 42.206C15.0115 42.8397 16.0185 42.9161 17.1636 42.2823L36.6151 31.4907",
    fill: "url(#paint2_linear_3279_8563)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6151 20.5091L17.1636 9.7175C16.0185 9.09025 15.0115 9.16663 14.394 9.80038L30.9912 26L36.6151 20.5091Z",
    fill: "url(#paint3_linear_3279_8563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3279_8563",
    x1: 29.5264,
    y1: 40.6775,
    x2: 7.71556,
    y2: 18.3381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3279_8563",
    x1: 45.5504,
    y1: 25.998,
    x2: 13.3322,
    y2: 25.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3279_8563",
    x1: 33.557,
    y1: 23.0149,
    x2: 3.97969,
    y2: -7.27908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3279_8563",
    x1: 10.2162,
    y1: 51.7709,
    x2: 23.4238,
    y2: 38.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLight);
export default __webpack_public_path__ + "static/media/google_play_light.ebef6fc07e34654acc3b7da9a41ada6c.svg";
export { ForwardRef as ReactComponent };